import { render, staticRenderFns } from "./TabsSongs.vue?vue&type=template&id=08b699d9"
import script from "./TabsSongs.vue?vue&type=script&lang=js"
export * from "./TabsSongs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports